import { Component, Vue } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { ShortcutHint } from '@/components/home/_components/tombola-shortcut-overlay/_domain/models/shortcut-hint';
import ShortcutOverlayItemComponent from '@/components/home/_components/tombola-shortcut-overlay/_components/shortcut-overlay-item';

@Component({
  name: 'TombolaShortcutOverlayComponent',
  components: {
    shortcutOverlayItem: ShortcutOverlayItemComponent
  }
})
export default class TombolaShortcutOverlayComponent extends TombolaBaseComponent {
  private get show(): boolean {
    return this.$modalManager.shouldShowShortcutOverlay;
  }

  private get shortcutHints(): ShortcutHint[] {
    return this.$modalManager.modalShortcutHints;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-shortcut-overlay/tombola-shortcut-overlay.component.ts